import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ZoneDetailSummary} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import DividerWithText from "../../../../components/DividerWithText";
import SubZonesDetailsTable from "./SubZonesDetailsTable";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const RenderExpandedRow = ({row}) => {
    const dispatch = useDispatch();
    const zoneId = row?.zoneId;

    // Fetch full zone detail (father + children) into redux on row expand.
    useEffect(() => {
        if (zoneId) {
            dispatch(ZoneDetailSummary({zoneId}));
        }
    }, [dispatch, zoneId]);

    // Full zone detail (children + device projection) fetched into redux on row expand.
    const {zoneDetailSummary} = useSelector((state) => state.EmployeeZonesSlice);
    // Detail uses `id`; the list row uses `zoneId`. Use the detail only once it matches this row.
    const zoneDetail = String(zoneDetailSummary?.id) === String(row?.zoneId)
        ? zoneDetailSummary
        : row;

    return (
        <>
            <DividerWithText/>
            <SubZonesDetailsTable
                table={true}
                zoneDetailFatherAndChild={zoneDetail}
                disabled={true}
                tableId={"tb_rer_subzone_table_"+ zoneId}
                searchId={"txt_rer_search_subzone_" + zoneId}
            />
        </>
    );
};

export default RenderExpandedRow
